module.exports = __webpack_public_path__ + "img/transformerCentent.5c2b0aa3.png";